import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DataColumns, TitledPaper } from 'cleveron-web-components';
import React from 'react';

import IssueLink from '../../../../IssueLink';
import Status from '../../Status';
import ActualDateForm from './ActualDateForm';

const useStyles = makeStyles(theme => ({
    dataTitle: {
        color: theme.palette.text.secondary,
    },
}));

function TaskInfo({ disabled, id, issue }) {
    const {
        address,
        apmName,
        apmSeries,
        apmSerial,
        description,
        dueDate,
        id: issueId,
        jiraIssueKey,
    } = issue || {};

    const info = [
        {
            key: 1,
            rows: [
                { key: 'apmName', value: apmName },
                { key: 'apmSeries', value: apmSeries },
                { key: 'apmSerial', value: apmSerial },
                { key: 'address', value: address },
                {
                    key: 'ticket',
                    nonTextual: true,
                    value: <IssueLink issue={{ accessible: true, id: issueId, jiraIssueKey }} />,
                },
                { key: 'dueDate', value: dueDate },
                {
                    key: 'actualDate',
                    nonTextual: true,
                    value: <ActualDateForm disabled={disabled} id={`${id}ActualDateForm`} />,
                },
            ],
        },
        {
            key: 2,
            rows: [{ key: 'description', value: description || '—' }],
        },
    ];

    const classes = useStyles();

    return (
        <TitledPaper
            actions={<Status disabled={disabled} domId={`${id}Status`} />}
            id={id}
            titleKey="task.info"
        >
            <Grid container spacing={2}>
                {info && (
                    <Grid item md xs={12}>
                        <DataColumns
                            alignItems="flex-start"
                            columns={info}
                            id={`${id}Info`}
                            titleClassName={classes.dataTitle}
                            translationKey="task.info"
                        />
                    </Grid>
                )}
            </Grid>
        </TitledPaper>
    );
}

export default TaskInfo;
